/*export const performSafeGoBack = history => {
  if(history==null || history==undefined){
    history.push('/');
  }
  if (history.length <= 3) {
    history.push('/');
  } else {
    history.goBack();
  }
}


export const navigateTo = navigate =>{
  
}*/
// Replaces performSafeGoBack using React Router v6 `navigate`
export const performSafeGoBack = (navigate) => {
  if (typeof navigate === 'function') {
    const canGoBack = window.history.length > 3;
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate('/');
    }
  } else {
    window.location.href = '/'; // fallback
  }
};

// Example usage of navigateTo (simple wrapper)
export const navigateTo = (navigate, path) => {
  if (typeof navigate === 'function' && path) {
    navigate(path);
  }
};
